
import { PasswordRecovery } from "../../classes";
const PasswordRecoveryModule = {
  namespaced: true,
  state: {
    passwordRecovery: null,
    passwordRecoveryStatus: "",
  },
  mutations: {
    setPasswordRecovery(state, payload) {
      state.passwordRecovery = payload.passwordRecovery
    },
    clearPasswordRecovery(state) {
      state.passwordRecovery = null
    },
    setPasswordRecoveryStatus(state, payload) {
      state.passwordRecoveryStatus = payload.passwordRecoveryStatus
    },
    clearPasswordRecoveryStatus(state) {
      state.passwordRecoveryStatus = ""
    },
  },
  actions: {
    getPasswordRecovery: async ({ commit }, payload) => {
      try {
        const data = await PasswordRecovery.getPasswordRecovery(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    createPasswordRecovery: async ({commit}, payload) => {
      try {
        const data = await PasswordRecovery.createPasswordRecovery(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    checkPasswordRecovery: async ({commit}, payload) => {
      try {
        const data = await PasswordRecovery.checkPasswordRecovery(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    changePasswordRecovery: async ({commit}, payload) => {
      try {
        const data = await PasswordRecovery.changePasswordRecovery(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getPasswordRecovery: (state) => {
      return state.PasswordRecovery
    }
  },
};
export default PasswordRecoveryModule;
